import { HierarchyRFMConfigProvider } from '../context/HierarchyRFMConfig';
import HierarchyRFMConfigContainer from './HierarchyRFMConfigContainer';

const HierarchyRFMConfig = () => {
  return (
    <HierarchyRFMConfigProvider>
      <HierarchyRFMConfigContainer />
    </HierarchyRFMConfigProvider>
  );
};

export default HierarchyRFMConfig;
